import * as React from 'react';
import { useParams } from 'react-router-dom';
import { OutboundEmail } from 'cb-model';
import { Display, NavIconContainer, PageTitle, QuerySingle, Section, useCloneEntity } from 'gossamer-front-end';

interface RenderEmailProps {
  value: string;
}

const RenderEmail = (props: RenderEmailProps) => {
  const ref = React.useRef<HTMLIFrameElement>(undefined);
  React.useEffect(() => {
    if (ref.current) {
      const doc = ref.current.contentWindow.document;
      doc.open('text/html', 'replace');
      doc.write(props.value);
      doc.close();
    }
  }, [ref.current]);
  return <iframe ref={ref} style={{ width: '100%', height: 2000 }}></iframe>;
};

export const OutboundEmailDisplay = (): React.JSX.Element => {
  const params = useParams();
  const LocalOutboundEmail = useCloneEntity(OutboundEmail, (local) => {
    local.fields.body.renderUneditable = RenderEmail;
  });
  return (
    <>
      <NavIconContainer entityId={OutboundEmail.id} />
      <PageTitle
        verb="Display"
        entity={OutboundEmail}
        keyValue={params.key}
        subtitle="Details relating to an Email sent by the system"
      />

      <Section>
        <QuerySingle entity={LocalOutboundEmail} keyValue={params.key} render={Display} />
      </Section>
    </>
  );
};
